import { useCallback, useEffect, useRef } from "react";
import { useAppDispatch } from "store";
import _ from "lodash";

export const useInterval = (callback: () => void, delay: number | null): void => {
  const savedCallback = useRef<() => void | null>(null);

  useEffect(() => {
    savedCallback.current = callback;
  });

  useEffect(() => {
    function tick() {
      savedCallback.current && savedCallback.current();
    }

    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};

export const useDebouncedDispatch = (delay: number = 300) => {
  const dispatch = useAppDispatch();

  const debouncedDispatch = useCallback(
    _.debounce((action: any) => {
      dispatch(action);
    }, delay),
    [dispatch, delay]
  );

  return debouncedDispatch;
};
